export default __webpack_public_path__ + "static/media/online-video.63f18f56.svg";